import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import { Link } from "react-router-dom";

const ImagePop = ({ tmsOdrNo }) => {
  //출발보고 URL 검색 URL
  //const IMAGE_URL = "http://tms.idaehan.com:8080/rn/rest/depart/getOrgAttachImage/" + tmsOdrNo;
  const IMAGE_URL =
    "https://tms.idaehan.com:8443/rn/rest/depart/getOrgAttachImage/" + tmsOdrNo;

  const SERARCH_DRRT_URL1 = IMAGE_URL + "/DPRT_01.do";
  const SERARCH_DRRT_URL2 = IMAGE_URL + "/DPRT_02.do";
  const SERARCH_ARRV_URL1 = IMAGE_URL + "/ARRV_01.do";
  const SERARCH_ARRV_URL2 = IMAGE_URL + "/ARRV_02.do";
  const [show, setShow] = useState(true);

  const handleClose = (returnData) => {
    setShow(false);
  };

  const handleOk = (returnData) => {
    setShow(false);
  };

  return (
    <>
      <Modal
        show={show}
        className="modal-fullscreen-md-down ims orenges"
        onHide={() => handleClose(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>사진</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className="mlist">
            <li className="fullhead">
              <div>
                출발보고 사진1
                <Link
                  to="#"
                  onClick={() => window.open(SERARCH_DRRT_URL1, "_blank")}
                >
                  [사진 링크]
                </Link>
              </div>
            </li>
            <li className="photo">
              <img src={SERARCH_DRRT_URL1} />
            </li>
            <li className="fullhead">
              <div>
                출발보고 사진2
                <Link
                  to="#"
                  onClick={() => window.open(SERARCH_DRRT_URL2, "_blank")}
                >
                  [사진 링크]
                </Link>
              </div>
            </li>
            <li className="photo">
              <img src={SERARCH_DRRT_URL2} />
            </li>
            <li className="fullhead">
              <div>
                도로영수증 사진1
                <Link
                  to="#"
                  onClick={() => window.open(SERARCH_ARRV_URL1, "_blank")}
                >
                  [사진 링크]
                </Link>
              </div>
            </li>
            <li className="photo">
              <img src={SERARCH_ARRV_URL1} />
            </li>
            <li className="fullhead">
              <div>
                계량증명서 사진2
                <Link
                  to="#"
                  onClick={() => window.open(SERARCH_ARRV_URL2, "_blank")}
                >
                  [사진 링크]
                </Link>
              </div>
            </li>
            <li className="photo">
              <img src={SERARCH_ARRV_URL2} />
            </li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalImagePop = createModal(ImagePop);

export default ImagePop;
